import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from '@heroicons/react/outline';
import logo from '../../images/logo_white-no-text.png';

export default function BadgeOnlyTopbar({ user, onLogout }) {
  return <nav aria-label="Main navigation" className="relative z-50 bg-red-600 text-white">
    <div className="mx-auto flex min-h-[64px] max-w-7xl items-center gap-3 px-3 sm:px-6">
      <Link to="/airport-badges" aria-label="Airport Badges home" className="shrink-0"><img src={logo} alt="LiveTakeoff" className="h-9 w-auto" /></Link>
      <Link to="/airport-badges" className="rounded-lg bg-red-700 px-3 py-3 text-sm font-medium">Airport Badges</Link>
      <Menu as="div" className="relative ml-auto">
        <Menu.Button className="flex min-h-[44px] items-center gap-1 rounded-lg px-2 text-sm focus:ring-2 focus:ring-white" aria-label="Account menu">
          <span className="hidden sm:inline">{user.fullName}</span><span className="sm:hidden">Account</span><ChevronDownIcon className="h-4 w-4" />
        </Menu.Button>
        <Transition as={Fragment} leave="transition duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
          <Menu.Items className="absolute right-0 mt-2 w-52 rounded-xl bg-white p-2 text-slate-800 shadow-lg ring-1 ring-black/5">
            <Menu.Item>{({ active }) => <Link className={`block rounded-lg px-3 py-3 ${active ? 'bg-slate-100' : ''}`} to="/user-settings/profile">My profile</Link>}</Menu.Item>
            <Menu.Item>{({ active }) => <Link className={`block rounded-lg px-3 py-3 ${active ? 'bg-slate-100' : ''}`} to="/user-settings/password">Password</Link>}</Menu.Item>
            <Menu.Item>{({ active }) => <button className={`w-full rounded-lg px-3 py-3 text-left ${active ? 'bg-slate-100' : ''}`} onClick={onLogout}>Sign out</button>}</Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  </nav>;
}
